import * as React from 'react'
import ActionButton from '../../../../general/ActionButton';
import TextContainer from '../../../../layout/TextContainer';
import CheckIcon from '@mui/icons-material/Check';
import { useLnRouterTrial } from '../../../../auth/plans/useLnRouterTrial';
import { sprayConfetti } from '../../../../general/prayConfetti';
import WhiteContainer from '../../../../layout/WhiteContainer';
import UserTrialAdBox from './UserTrialAdBox';

type Props = {
  onClose?: () => any
}



const UserTrialAd: React.FC<Props> = ({ onClose }) => {
  const trial = useLnRouterTrial();


  if (!trial.available) {
    return <React.Fragment />
  }

  return (
    <div >
      {!trial.available &&
        <React.Fragment />
      }
      {trial.available &&

        <TextContainer className='flex'>

          <UserTrialAdBox onClose={onClose} />
        </TextContainer>
      }

    </div>
  );
}

export default UserTrialAd;

